import type { Locale } from '../../../../types';
import { getLangFromLocale } from '../utils/getLangFromLocale';
import { GLOBAL_POSTPROCESSOR } from '../constants';
import type { PostProcessor, PostProcessorsRootMap } from './types';

const passThroughProcessor = (v: string): string => v;

const createPostProcessor = <F extends string, Settings>(
    postProcessorsMap: PostProcessorsRootMap<F, Settings>,
    locale: Locale
) => {
    const lang = getLangFromLocale(locale);
    const generatedProcessorsByLocale = new Map<F, PostProcessor<Settings>[]>();

    // order to run processor-pipes
    const pipeKeys = Array.from(new Set([GLOBAL_POSTPROCESSOR, lang, locale]));

    pipeKeys.forEach((key) => {
        const postProcessorsMapByFormat = postProcessorsMap[key];

        if (!postProcessorsMapByFormat) return;

        for (const format in postProcessorsMapByFormat) {
            const pp = postProcessorsMapByFormat[format];
            if (!pp) continue;
            
            if (!generatedProcessorsByLocale.has(format)) {
                generatedProcessorsByLocale.set(format, []);
            }
            // (!) наличие элемента обеспечено логикой выше
            generatedProcessorsByLocale.get(format)!.push(pp);
        }
    });

    return (
        v: string,
        format: F,
        settings: Settings
    ) => {
        const processors = generatedProcessorsByLocale.get(format);
        
        if (!processors || processors.length === 0) {
            return passThroughProcessor(v);
        }

        return processors.reduce(
            (acc, processor) => processor(acc, settings),
            v
        );
    };
};

export {
    createPostProcessor,
}
